		<div class="topBar" id="topBar">
		<div class="menu">
			<a routerLink="/" aria-label="Home"><div class="logo"></div></a>
			<div class="spacer"></div>
			<nav [ngClass]="{ 'show': navbarOpen }" (click)="closeNavbar()">
        <div class="menuContainer">
          <a routerLink="/guide" routerLinkActive="active" class="menuItem" (click)="closeNavbar()">Guide</a>
          <a routerLink="/pricing" routerLinkActive="active" class="menuItem" (click)="closeNavbar()">Pricing</a>
          <a routerLink="/enterprise" routerLinkActive="active" class="menuItem" (click)="closeNavbar()">Enterprise</a>
          <a routerLink="/features" routerLinkActive="active" class="menuItem" (click)="closeNavbar()">Features</a>
          <a routerLink="/home" routerLinkActive="active" class="menuItem" (click)="closeNavbar()">Home</a>
        </div>
			</nav>
			<div class="hamburger" tabindex="0" role="link" (click)="toggleNavbar()" (keypress)="toggleNavbar()">
				<div class="bar1" [ngClass]="{ 'open': navbarOpen }"></div>
				<div class="bar2" [ngClass]="{ 'open': navbarOpen }"></div>
				<div class="bar3" [ngClass]="{ 'open': navbarOpen }"></div>
			</div>
		</div>
	</div>
	<div class="outerPage">
		<div class="page" [class]="!isLoaded ? 'invisible' : 'visible'">
			<router-outlet>
      </router-outlet>
		</div>
    <div class="loaderContainer" *ngIf="!isLoaded">
      <div class="loader"></div>
    </div>
	</div>
  <!--<div class="pinnedFooter">
    <footer></footer>
  </div>-->
  <div class="footer">
    <footer></footer>
  </div>




